import { COLORS } from '@btime/constants'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import PdfDocument from './PdfDocument'
import PdfOptionsFormHandler from '../../../components/pdf/options/_form/PdfOptionsFormHandler'
// import Preview from '../../../components/pdf/Preview'
import Preview from './_shared/Preview'
import LandscapePreview from './_shared/LandscapePreview'

const PageContent = ({ templateId }) => {
  const content = () => {
    if ([6, 7, 8, 9, 10, 11].includes(templateId)) {
      return (
        <LandscapePreview>
          <PdfDocument templateId={templateId} />
        </LandscapePreview>
      )
    }
    return (
      <Preview>
        <PdfDocument templateId={templateId} />
      </Preview>
    )
  }
  return (
    <PdfOptionsFormHandler initialState={{ fontBaseColor: COLORS.black, fontBase: 13 }}>
      <Grid align="stretch">
        <Col flex={3} flex_mdd={0} hideOn="mdd" scroll height="calc(100vh - 4.8rem)">
          {content()}
        </Col>
      </Grid>
    </PdfOptionsFormHandler>
  )
}

export default PageContent
